import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, Installation, InstallationsService } from '@ubie/core';
import { FeedbackService } from '@ubie/shared';

@Component({
  selector: 'acl-installation-invitation',
  standalone: false,
  templateUrl: './installation-invitation.component.html',
  styleUrl: './installation-invitation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationInvitationComponent {
  private readonly installationsService = inject(InstallationsService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly feedbackService = inject(FeedbackService);

  readonly installation = input<Installation>();

  readonly isCurrentInstallerConfirmed = computed(() => {
    const installation = this.installation();
    const userId = this.authService.getUserId();
    if (!installation || !userId) {
      return false;
    }

    if (installation.installer2?.id === userId) {
      return Boolean(installation.installer2IdConfirmed);
    }

    if (installation.installer?.id === userId) {
      return Boolean(installation.installerIdConfirmed);
    }

    return false;
  });

  readonly address = computed(() => {
    const installation = this.installation();
    if (installation) {
      let address = '';
      if (installation.addressLine1) {
        address = installation.addressLine1 + ', ';
      }

      if (installation.postalCode) {
        address += installation.postalCode + ', ';
      }

      if (installation.city) {
        address += installation.city + ', ';
      }

      if (
        installation.country &&
        Object.prototype.hasOwnProperty.call(installation.country, 'name')
      ) {
        address += installation.country.name;
      }

      return address;
    }
    return '';
  });

  readonly hideButton = signal<boolean>(false);

  /**
   * To installation button was clicked
   */
  toInstallationClicked(): Promise<boolean> {
    return this.router.navigate([
      '/installation/' + this.installation()?.id + '/detail',
    ]);
  }

  /**
   * Accept invite to become the installer of the installation
   */
  acceptInstallationByInstaller(): void {
    const installation = this.installation();
    if (!installation) {
      return;
    }

    this.installationsService
      .acceptInstallationByInstaller(
        installation.id,
        this.authService.getUserId() ?? 0,
      )
      .subscribe({
        next: () => {
          this.hideButton.set(true);
        },
        error: (error) => {
          this.feedbackService.present(
            error.error.errorMessage,
            5000,
            true,
            'danger',
          );
        },
      });
  }
}
